import services from '@/config/services'
// import moment from 'moment'

export default class ContrattiVenditaService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async clonaContratti(config){
    let item = {
      contracts: [],
      success: false
    }

    const url = `${this.baseUrl}/contratti/vendita/clonazione`

    try {
      let res = await this.http.post(url, {
        data: config.data,
        filters: {
          'contratto_vendita.ids': config.ids
        }
      })

      res = res.data
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return item
    }
  }

  async modificaContratti(config){
    let success = false
    const url = `${this.baseUrl}/contratti/vendita/modifica`

    try {
      let res = await this.http.put(url, {
        data: config.data,
        filters: {
          'contratto_vendita.ids': config.ids
        }
      })
      
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

}
